import { render, staticRenderFns } from "./CustomHeader.vue?vue&type=template&id=116e065a&scoped=true&"
import script from "./CustomHeader.vue?vue&type=script&lang=js&"
export * from "./CustomHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomHeader.vue?vue&type=style&index=0&id=116e065a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e065a",
  null
  
)

export default component.exports